import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styled';
import ModalInviteUser from './ModalInviteUser';
import CommonModal from '../../../../components/UI/CommonModal';
import AlertMessage from '../../../../components/UI/AlertMessage';
import TableUserManagement from '../../../../components/UI/TableUserManagement';
import { ALERT_TYPES } from '../../../../enums';
import { useContextInfo } from '../../../../context';
import { useQuery } from '@apollo/client';
import { GET_ALL_SITES } from '../../../../apollo/settings';

const UserManagement = () => {
  const { t } = useTranslation();

  const [isOpenActionModal, setIsOpenActionModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [alertStatus, setAlertStatus] = useState(ALERT_TYPES.SUCCESS);

  const { data: allSites } = useQuery(GET_ALL_SITES);
  const { selectedSite, setSelectedSite } = useContextInfo();
  const [siteOptions, setSiteOptions] = useState(null);
  const [selectedSiteValue, setSelectSiteValue] = useState(selectedSite);

  const handlerCloseActionModal = () => {
    setIsOpenActionModal(false);
  };

  const handlerAction = (text, status = ALERT_TYPES.SUCCESS) => {
    setAlertText(text);
    setAlertStatus(status);
    setOpenAlert(true);
  };

  const closeAlert = () => {
    setAlertText('');
    setOpenAlert(false);
  };

  const handlerSiteSelect = (e) => {
    const currentValue = siteOptions?.find((item) => item.id === e.target.value);
    setSelectSiteValue(currentValue?.value);
    setSelectedSite(currentValue?.value);
  };

  useEffect(() => {
    if (allSites?.sites?.length) {
      const options = allSites?.sites?.map((item) => {
        return {
          id: item.id,
          value: item.id,
          name: item.name
        };
      });

      setSiteOptions(options);
      if (!selectedSite) {
        setSelectSiteValue(options[0]?.value);
      }
    }
  }, [allSites]);

  const handlerOpenActionModal = () => setIsOpenActionModal(true);

  return (
    <S.Wrapper>
      <AlertMessage
        open={openAlert}
        onClose={closeAlert}
        errorText={alertText}
        severity={alertStatus}
      />
      {siteOptions && (
        <S.SelectSiteStyle
          options={siteOptions}
          onChange={handlerSiteSelect}
          value={selectedSiteValue}
        />
      )}
      <CommonModal open={isOpenActionModal} onClose={handlerCloseActionModal}>
        <ModalInviteUser onClose={handlerCloseActionModal} handlerAction={handlerAction} />
      </CommonModal>
      {/*<S.InviteButtonBlock>
            <CommonButton text={t('modal.invite_user')} onClick={handlerOpenActionModal} />
        </S.InviteButtonBlock>*/}
      <TableUserManagement selectedSite={selectedSiteValue} />
    </S.Wrapper>
  );
};

export default UserManagement;
